<template>
    <div class="menu-category-container" :id="catName" v-if="catItems.length > 0">
        <h1 class="menu-category-name">{{catName}}</h1>
        <hr>
        <div class="menu-items-grid">
            <MenuItem @toshow="(ob)=>{$emit('toshow', ob)}" v-for="item in catItems" :key="item.code" :MenuItem="item" :shop="shop"/>
        </div>
    </div>
</template>

<script>
import MenuItem from './MenuItem'

export default {
    props:['MenuCat', 'shop'],
    computed:{
        catName: function () {
            return this.MenuCat[0]
        },
        catItems: function () {
            return this.MenuCat[1]
        }
    },
    components: {
        MenuItem
    }

}
</script>